import { VERSIONS_REQUEST, VERSIONS_SHOW, VERSION_EDIT, VERSIONS_FAIL, VERSION_CLEAR, VERSIONS_LIST
} from './../store/config';

const versionsDefault = {
    isFetching: false,
	list: {},
	edit: {
		phases_groups:[]
	},
	pages: {
		current: 0,
		per_page: 0,
		total: 0
	},
	permissions: [],
    error: undefined,
    timestamp: undefined
}

const versions= (state = versionsDefault, action) => {
	switch(action.type) {
        case VERSIONS_REQUEST:{
            return {
                ...state,
                isFetching: action.isFetching,
                timestamp: action.timestamp
            }
        }
		case VERSIONS_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
                list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case VERSIONS_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case VERSION_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: {
					...state.edit,
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case VERSION_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case VERSIONS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default versions;



// WEBPACK FOOTER //
// ./src/reducers/versions.js